var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReviewSms = function SvgReviewSms(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 29.0952C11.929 29.0952 12.9524 28.0719 12.9524 26.8095C12.9524 25.5472 11.929 24.5238 10.6667 24.5238C9.4043 24.5238 8.38095 25.5472 8.38095 26.8095C8.38095 28.0719 9.4043 29.0952 10.6667 29.0952Z",
    fill: "#7EAAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61902 6.23792C7.61902 5.39635 8.30125 4.71411 9.14283 4.71411H12.1905C13.032 4.71411 13.7143 5.39635 13.7143 6.23792C13.7143 7.0795 13.032 7.76174 12.1905 7.76174H9.14283C8.30125 7.76174 7.61902 7.0795 7.61902 6.23792Z",
    fill: "#7EAAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80953 0.1427C1.70559 0.1427 0 1.84828 0 3.95223V29.857C0 31.961 1.70559 33.6666 3.80953 33.6666H17.5238C19.6278 33.6666 21.3334 31.961 21.3334 29.857V23H18.2857V29.857C18.2857 30.2778 17.9446 30.6189 17.5238 30.6189H3.80953C3.38874 30.6189 3.04762 30.2778 3.04762 29.857V3.95223C3.04762 3.53144 3.38874 3.19032 3.80953 3.19032H17.5238C17.9446 3.19032 18.2857 3.53144 18.2857 3.95223V9H21.3334V3.95223C21.3334 1.84829 19.6278 0.1427 17.5238 0.1427H3.80953Z",
    fill: "#7EAAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22.5H28.5V29.25L21.75 22.5H15V9H33V22.5Z",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 13.5H19.5",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 18H19.5",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReviewSms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/review_sms.1b59ce76.svg";
export { ForwardRef as ReactComponent };